// 解析图片路径
export function extractImagePath(jsonString) {
  if (jsonString) {
    try {
      // 将 JSON 字符串解析为对象
      const parsedJson = JSON.parse(jsonString);
      // 检查是否为数组且数组中有值
      if (Array.isArray(parsedJson) && parsedJson.length > 0) {
        const url = parsedJson[0] || "";
        // 返回第一个元素
        return url.startsWith("/") ? `${process.env.VUE_APP_IP}${parsedJson[0]}` : url;
      } else {
        // 非数组为0的情况输出错误json字符串
        if (!(Array.isArray(parsedJson) && parsedJson.length === 0)) {
          console.warn("JSON 数据格式不符合预期，无法提取路径");
          console.warn(jsonString);
        }
        return null;
      }
    } catch (error) {
      console.error("解析 JSON 时出错：", error);
      return null;
    }
  }
}

export function JSONImgAddPath(jsonString) {
  if (jsonString) {
    // 定义一个函数来处理每个匹配的 <img> 标签
    const replaceImgSrc = (match, p1) => {
      // 检查 src 是否以 http 或 https 开头
      if (!p1.startsWith("http")) {
        // 如果不是，则加上指定的域名
        return `<img src="${process.env.VUE_APP_IP}${p1}"`;
      }
      // 如果是 http 或 https 地址，则不做处理
      return match;
    };

    // 使用正则表达式替换 <img> 标签的 src 属性
    return jsonString.replace(/<img src="([^"]+)"/g, replaceImgSrc);
  }
}

// 打开百度地图
export function goToLocation(address = "") {
  if (!address) return;
  // 对地址进行编码，避免特殊字符导致问题
  const encodedAddress = encodeURIComponent(address);
  // 构造百度地图的搜索 URL
  const url = `http://api.map.baidu.com/marker?location=39.915,116.404&title=${encodedAddress}&content=${encodedAddress}&output=html`;
  // 判断设备类型
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /mobile|android|iphone|ipad|phone/.test(userAgent);
  if (isMobile) {
    // 移动端
    window.location.href = url;
  } else {
    // PC端
    window.open(url, "_blank");
  }
}

// 将时间戳转换为 YYYY/MM/DD 格式的日期字符串
// export function formatDate(timestamp, format) {
//   if (isNaN(timestamp)) {
//     return "";
//   }
//   const date = new Date(timestamp);
//   const year = date.getFullYear(); // 获取年份
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // 获取月份
//   const day = String(date.getDate()).padStart(2, "0"); // 获取日期
//   // 返回日期字符串
//   return `${year}/${month}/${day}`;
// }

export function formatDate(timestamp, format = 'YYYY/MM/DD') {
  if (isNaN(timestamp)) {
    return "";
  }
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");

  let formattedDate = format;
  formattedDate = formattedDate.replace(/YYYY/g, year);
  formattedDate = formattedDate.replace(/MM/g, month);
  formattedDate = formattedDate.replace(/DD/g, day);
  formattedDate = formattedDate.replace(/HH/g, hour);
  formattedDate = formattedDate.replace(/mm/g, minute);
  formattedDate = formattedDate.replace(/ss/g, second);

  return formattedDate;
}

export function formatDateTime(timestamp, format = 'YYYY/MM/DD HH:mm:ss') {
  return formatDate(timestamp, format);
}

export function scrollIntoView(element, timer) {}

// 跳转到指定页面
export async function goToPages(config = {}) {
  const { name, query, path, elementId, behavior = "smooth", target = "_self" } = config;
  if (!name && !path) {
    return this.$message.warning("当前页面模块暂未开放");
  }
  // 跳转到指定页面
  if (target === "_blank") {
    // 构建完整URL
    let url = '';
    if (name) {
      url = this.$router.resolve({ name, query }).href;
    } else {
      url = this.$router.resolve({ path, query }).href;
    }
    window.open(url, '_blank');
  } else {
    if (name) {
      await this.$router.push({ name, query });
    } else {
      await this.$router.push({ path, query });
    }
    // 恢复默认主题
    this.$store.dispatch("setting/setDataTheme", "dark");
    this.$store.dispatch("setting/setCollapse", false);
    // 延时执行,等待页面渲染完成
    setTimeout(() => {
      // 有锚点滚动到锚点元素
      if (elementId) {
        const element = document.getElementById(elementId);
        element && element.scrollIntoView({ behavior, inline: "start" });
      }
      // 否则滚动到页面顶部
      else {
        document.body.scrollIntoView({ behavior, block: "start" });
      }
    }, 800);
  }
}

// 检测字符串是否为正确的url
function isValidURL(string) {
  var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  return (res !== null);
}

/**
 * 验证是否为正确的 JSON 字符串
 * @param {string} jsonString - 待验证的字符串
 * @returns {boolean} 如果是有效的 JSON 字符串返回 true，否则返回 false
 */
export function isValidJsonString(jsonString) {
  if (jsonString) {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}

// 滚动到指定位置
export function scrollPosition(position) {
  setTimeout(() => {
    let thePosition = 0
    if (position && position.scroll) {
      thePosition = position.scroll
    }
    console.log(`scrollPosition => ${thePosition}`)
    console.log(thePosition)
    // 从Vuex读取并应用滚动位置
    window.scrollTo(0, thePosition);
  }, 600)
}

export default {
  extractImagePath,
  JSONImgAddPath,
  goToLocation,
  formatDate,
  formatDateTime,
  goToPages,
  isValidURL,
  isValidJsonString,
  scrollPosition
};
